import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { editTeam, updateTeamSetting } from "../../services/team.services";
import { UpdateSelectedTeam } from "../../redux/actions/team.actions";
import CheckBox from "@mui/material/Checkbox";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CircularProgress from "@mui/material/CircularProgress";
import "./SettingTurnoverDescription.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar";
import AddTurnoverModal from "./component/AddTurnoverModal";

const SettingTurnoverDescription = () => {
  const dispatch = useDispatch();
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const user = useSelector((state) => state.auth.user);

  const [initialFormState, setInitialFormState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [newTurnover, setNewTurnover] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [skipTurnoverDescriptions, setSkipTurnoverDescriptions] = useState(false);

  useEffect(() => {
    if (operatorTeam?.teamId?.turnover_options) {
      setInitialFormState(operatorTeam.teamId.turnover_options);
    }
  }, [operatorTeam?.teamId?.turnover_options]);

  useEffect(() => {
    const storedValue = localStorage.getItem("skipTurnoverDescriptions");
    if (storedValue !== null) {
      setSkipTurnoverDescriptions(JSON.parse(storedValue));
    }
  }, []);

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;
    setSkipTurnoverDescriptions(newValue);
    localStorage.setItem("skipTurnoverDescriptions", JSON.stringify(newValue));
  };

  const toggleInfoOverlay = () => setIsVisible(!isVisible);

  const toggleSuccessModal = () => {
    setSuccessVisible(true);
    setTimeout(() => setSuccessVisible(false), 2500);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      await editTeam(
        {
          teamId: operatorTeam?.teamId._id,
          turnover_options: [
            ...initialFormState,
            {
              displayName: newTurnover,
              slug: newTurnover.toLowerCase().replace(/\s+/g, "_"),
            },
          ],
        },
        user?.token
      );
      // toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setNewTurnover("");
      setAddModalVisible(false);
    } catch (e) {
      console.error("Error at Add New Turnover ===>", e);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (index) => {
    try {
      setLoading(true);
      const updatedOptions = [...initialFormState];
      updatedOptions.splice(index, 1);
      await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          turnover_options: updatedOptions,
        },
        user?.token
      );
      // toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setInitialFormState(updatedOptions);
    } catch (e) {
      console.error("Error at Delete Turnover ===>", e);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    if (editIndex === null) return;
    try {
      setLoading(true);
      const updatedOptions = [...initialFormState];
      updatedOptions[editIndex] = {
        displayName: newTurnover,
        slug: newTurnover.toLowerCase().replace(/\s+/g, "_"),
      };
      await editTeam(
        {
          teamId: operatorTeam?.teamId._id,
          turnover_options: updatedOptions,
        },
        user?.token
      );
      // toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setNewTurnover("");
      setEditIndex(null);
      setEditModalVisible(false);
      setInitialFormState(updatedOptions);
    } catch (e) {
      console.error("Error at Edit Turnover ===>", e);
    } finally {
      setLoading(false);
    }
  };

  const handleResetToDefault = async () => {
    if (!window.confirm("Are you sure you want to reset to default?")) return;

    try {
      setLoading(true);
      const settingName = "turnover_options";
      const teamId = operatorTeam?.teamId._id;
      const token = user?.token;
      await updateTeamSetting(settingName, teamId, token);
      // toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setInitialFormState([]);
    } catch (e) {
      console.error("Error at Reset Turnover Descriptions:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-rating-container">
      <UserSidebar />
      <div className="settings-rating-header">
        <button className="defaultBtn" onClick={handleResetToDefault}>
          Reset to Default
        </button>
        <button onClick={() => setAddModalVisible(true)} className="plusBtnTurnover">
          {/* <AddCircleOutlineIcon style={{ marginRight: "8px", color: "red" }} /> */}
          Add a description
        </button>
        {/* <CheckBox
          checked={skipTurnoverDescriptions}
          onChange={handleCheckboxChange}
        />
        <span>Don’t need Additional Descriptions</span>
        <button onClick={toggleInfoOverlay} className="infoBtn">
          <InfoOutlinedIcon />
        </button> */}
      </div>
      <div style={{ display: 'flex', justifyContent: 'end', marginRight: '50px' }}>
        <div className="turnoverList">
          {initialFormState?.map((v, i) => (
            <div key={i} className="turnoverItem">
              <span>{v.displayName}</span>
              {/* <button
                className="delBtn-technical-pen-settings" style={{background: "#0a2540"}}
                onClick={() => {
                  setEditIndex(i);
                  setNewTurnover(v.displayName);
                  setEditModalVisible(true);
                }}>Edit</button> */}
              <button
                className="delBtn-technical-pen-settings"
                onClick={() => handleDelete(i)}>Delete</button>
            </div>
          ))}
        </div>
      </div>

      {/* Add Modal */}
      <AddTurnoverModal
        onBackdropPress={() => setAddModalVisible(false)}
        visible={addModalVisible}
        newTurnover={newTurnover}
        setNewTurnover={setNewTurnover}
        handleSave={handleSave}
        turnoverModalHeading="Add Turnover Option"
      />

      {/* Edit Modal */}
      <AddTurnoverModal
        onBackdropPress={() => setEditModalVisible(false)}
        visible={editModalVisible}
        newTurnover={newTurnover}
        setNewTurnover={setNewTurnover}
        handleSave={handleEdit}
        turnoverModalHeading="Edit Turnover Option"
      />


      {/* Success Message */}
      {successVisible && <div className="successMsg">Updated successfully!</div>}

      {/* Info Overlay */}
      {isVisible && (
        <div className="overlay">
          <div className="overlayContent">
            <CloseIcon className="closeBtn" onClick={toggleInfoOverlay} />
            <p>
              When you press the TURNOVER Button the app will automatically
              display the Additional Turnover Descriptions listed here for you to
              select from. If you don’t want to use this feature, check the checkbox.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingTurnoverDescription;

